import * as moment from 'moment';

export default {
  // containerClass: 'theme-red',
  // isAnimated: true,
  localeData: {firstDay: 1, format: 'YYYY-MM-DD'},

  rangeInputFormat: 'YYYY-MM-DD',
  showWeekNumbers: false,
  autoApply: true,
  showPreviousMonth: true,
  ranges: {
    'Today': [
      new Date(),
      new Date()
    ],
    'Yesterday': [
      moment().subtract(1, 'day').toDate(),
      moment().subtract(1, 'day').toDate(),
    ],
    'This week': [
      moment().isoWeekday(1).toDate(),
      moment().isoWeekday(7).toDate(),
    ],
    'Last week': [
      moment().isoWeekday(-6).toDate(),
      moment().isoWeekday(0).toDate()
    ],
    'This month': [
      moment().date(1).toDate(),
      moment().date(31).toDate()
    ],
    'Last month': [
      moment().subtract(1, 'month').date(1).toDate(),
      moment().subtract(1, 'month').date(31).toDate()
    ],
    'This year': [
      moment().dayOfYear(1).toDate(),
      moment().dayOfYear(366).toDate(),
    ],
    'Last year': [
      moment().dayOfYear(1).subtract(1, 'year').toDate(),
      moment().dayOfYear(366).subtract(1, 'year').toDate(),
    ]

  }
}

